<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>What is, is not; and, what is not, is…<br/>—The Trickster</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page7.vue?eb60e918